import { type InsuranceCorporateIdentity } from "../types";

export function DAKLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M445.256 193V216.578H273.705L324.997 317.824H292.073L282.369 301.181H225.531L217.56 317.824H183.943L234.889 216.578H64.3767V193H445.256ZM187.409 264.427C187.755 264.427 187.755 285.925 187.409 286.271C187.755 286.618 187.755 318.171 159.683 317.824C159.337 318.171 64.0301 318.171 64.3767 317.824V232.181H155.178C189.835 232.528 187.409 264.08 187.409 264.427ZM157.95 280.377V268.935C157.95 261.653 156.911 256.452 147.553 256.799H92.7954C93.1419 256.452 92.4488 294.593 92.7954 294.246H149.979C155.871 294.246 157.95 286.965 157.95 280.377ZM235.582 277.603H272.665L254.643 237.382L235.582 277.603ZM397.776 275.176L455.653 317.824H409.906L372.477 287.312H356.881V317.824H327.423V232.181H356.881V262.693H372.477L408.867 232.181H452.881L397.776 275.176Z"
        fill="white"
      />
    </svg>
  );
}

export const DAK: InsuranceCorporateIdentity = {
  id: "dak",
  name: "DAK-Gesundheit",
  logo: DAKLogo,
  backgroundColor: "#F07D00",
  textColor: "#FFFFFF",
  wildcard: "dak",
  type: "statutory",
  description:
    "Deutsche Angestellten-Krankenkasse - statutory health insurance",
};
